/* eslint-disable */
// Detect CSS transform support
//
const transform = (function () {
	var vendors = ['webkit', 'moz', 'ms'];
	var style = document.createElement("div").style;
	var trans = 'transform' in style ? 'transform' : undefined;

	for (var i = 0, count = vendors.length; i < count; i++) {
		var prop = vendors[i] + 'Transform';
		if (prop in style) {
			trans = prop;
			break;
		}
	}

	return trans;
})();
const cancelFrame = window.cancelAnimationFrame || window.cancelRequestAnimationFrame;
const requestFrame = window.requestAnimationFrame;
const Item = function (element, options) {
	element.item = this;
	this.element = element;

	if (element.tagName === 'IMG') {
		this.fullWidth = element.width;
		this.fullHeight = element.height;
	} else {
		element.style.display = "inline-block";
		this.fullWidth = element.offsetWidth;
		this.fullHeight = element.offsetHeight;
	}

	element.style.position = 'absolute';

	if (options.mirror && this.element.tagName === 'IMG') {
		// Wrap image in a div together with its generated reflection
		this.reflection = $(element).reflect(options.mirror).next()[0];

		var $reflection = $(this.reflection);
		this.reflection.fullHeight = $reflection.height();
		$reflection.css('margin-top', options.mirror.gap + 'px');
		$reflection.css('width', '100%');
		element.style.width = "100%";

		// The item element now contains the image and reflection
		this.element = this.element.parentNode;
		this.element.item = this;
		this.element.alt = element.alt;
		this.element.title = element.title;
	}

	if (transform && options.transforms)
		this.element.style[transform + "Origin"] = "0 0";

	this.moveTo = function (x, y, scale) {
		this.width = this.fullWidth * scale;
		this.height = this.fullHeight * scale;
		this.x = x;
		this.y = y;
		this.scale = scale;

		var style = this.element.style;
		style.zIndex = "" + (scale * 100) | 0;
		if (transform && options.transforms) {
			style[transform] = "translate(" + x + "px, " + y + "px) scale(" + scale + ")";
		} else {
			// The gap between the image and its reflection doesn't resize automatically
			if (options.mirror && this.element.tagName === 'IMG')
				this.reflection.style.marginTop = (options.mirror.gap * scale) + "px";

			style.width = this.width + "px";
			style.left = x + "px";
			style.top = y + "px";
		}
	}
}
const time = !window.performance || !window.performance.now ?
	function () { return +new Date() } :
	function () { return performance.now() };

export default class Carousel {
	constructor(options) {
		this.options = $.extend({
			xOrigin: null, // null: calculated automatically
			yOrigin: null,
			xRadius: null,
			yRadius: null,
			farScale: 0.8, // scale of the farthest item
			transforms: true, // enable CSS transforms
			smooth: true, // enable smooth animation via requestAnimationFrame()
			fps: 40, // fixed frames per second (if smooth animation is off)
			speed: 4, // positive number
			autoPlay: 0, // [ 0: off | number of items (integer recommended, positive is clockwise) ]
			autoPlayDelay: 60000,
			bringToFront: false,
			itemClass: 'carousel_item',
			handle: 'carousel'
		}, options);

		this.$container = this.options.el;
		this.items = [];
		this.xOrigin = (this.options.xOrigin === null) ? this.$container.width() * 0.5 : this.options.xOrigin;
		this.yOrigin = (this.options.yOrigin === null) ? this.$container.height() * 0.1 : this.options.yOrigin;
		this.xRadius = (this.options.xRadius === null) ? this.$container.width() / 1 : this.options.xRadius;
		this.yRadius = (this.options.yRadius === null) ? this.$container.height() / 6 : this.options.yRadius;
		this.farScale = this.options.farScale;
		this.rotation = this.destRotation = Math.PI / 2; // start with the first item positioned in front
		this.speed = this.options.speed;
		this.smooth = this.options.smooth;
		this.fps = this.options.fps;
		this.timer = 0;
		this.autoPlayAmount = this.options.autoPlay;
		this.autoPlayDelay = this.options.autoPlayDelay;
		this.autoPlayTimer = 0;
		this.onLoaded = this.options.onLoaded;
		this.onRendered = this.options.onRendered;

		this.itemOptions = {
			transforms: this.options.transforms
		}

		if (this.options.mirror) {
			this.itemOptions.mirror = $.extend({ gap: 2 }, this.options.mirror);
		}

		this.playFrame = this.playFrame.bind(this);

		this.$container.css({ position: 'relative' });
		this.initTimer = setInterval(() => {
			this.finishInit();
		}, 50);
	}

	// Rotation:
	//  *      0 : right
	//  *   Pi/2 : front
	//  *   Pi   : left
	//  * 3 Pi/2 : back
	renderItem(itemIndex, rotation) {
		var item = this.items[itemIndex];
		var sin = Math.sin(rotation);
		var farScale = this.farScale;
		var scale = farScale + ((1 - farScale) * (sin + 1) * 0.5);
		item.moveTo(
			this.xOrigin + (scale * ((Math.cos(rotation) * this.xRadius) - (item.fullWidth * 0.5))),
			(this.options.el.height() - $(item.element).height()) * 0.5 + (scale * sin * this.yRadius),
			scale
		);
	}

	render() {
		var count = this.items.length;
		var spacing = 2 * Math.PI / count;
		var radians = this.rotation;

		for (var i = 0; i < count; i++) {
			this.renderItem(i, radians);
			radians += spacing;
		}

		var sin = Math.sin(0);
		var farScale = this.farScale;
		var scale = farScale + ((1 - farScale) * (sin + 1) * 0.5);
		if (typeof this.onRendered === 'function') {
			this.onRendered(this, (scale * this.yRadius));
		}
	}

	playFrame() {
		var rem = this.destRotation - this.rotation;
		var now = time();
		var dt = (now - this.lastTime) * 0.002;
		this.lastTime = now;

		if (Math.abs(rem) < 0.003) {
			this.rotation = this.destRotation;
			this.pause();
		} else {
			// Rotate asymptotically closer to the destination
			this.rotation = this.destRotation - rem / (1 + (this.speed * dt));
			this.scheduleNextFrame();
		}

		this.render();
	}

	scheduleNextFrame() {
		this.lastTime = time();

		this.timer = this.smooth && cancelFrame ?
			requestFrame(this.playFrame) :
			setTimeout(this.playFrame, 1000 / this.fps);
	}

	itemsRotated() {
		return this.items.length * ((Math.PI / 2) - this.rotation) / (2 * Math.PI);
	}

	floatIndex() {
		var count = this.items.length;
		var floatIndex = this.itemsRotated() % count;
		// Make sure float-index is positive
		return (floatIndex < 0) ? floatIndex + count : floatIndex;
	}

	nearestIndex() {
		return Math.round(this.floatIndex()) % this.items.length;
	}

	nearestItem() {
		return this.items[this.nearestIndex()];
	}

	play() {
		if (this.timer === 0)
			this.scheduleNextFrame();
	}

	pause() {
		this.smooth && cancelFrame ? cancelFrame(this.timer) : clearTimeout(this.timer);
		this.timer = 0;
	}

	// Spin the carousel.  Count is the number (+-) of carousel items to rotate
	go(count) {
		this.destRotation += (2 * Math.PI / this.items.length) * count;
		this.play();
	}

	deactivate() {
		this.pause();
		clearInterval(this.autoPlayTimer);
		this.$container.unbind('.cloud9');
	}

	autoPlay() {
		this.autoPlayTimer = setInterval(() => {
			this.go(this.autoPlayAmount)
		}, this.autoPlayDelay);
	}

	enableAutoPlay() {
		this.autoPlay();
	}

	bindControls() {
		if (this.options.bringToFront) {
			this.$container.bind('click.cloud9', event => {
				var hits = $(event.target).closest('.' + this.options.itemClass);

				if (hits.length !== 0) {
					var idx = this.items.indexOf(hits[0].item);
					var count = this.items.length;
					var diff = idx - (this.floatIndex() % count);

					// Normalise "diff" to represent the shortest way to rotate item to front
					if (2 * Math.abs(diff) > count)
						diff += (diff > 0) ? -count : count;

					// Suppress default browser action if the item isn't roughly in front
					if (Math.abs(diff) > 0.5)
						event.preventDefault();

					// Halt any rotation already in progress
					this.destRotation = this.rotation;

					this.go(-diff);
				}
			});
		}
	}

	finishInit() {
		var items = this.$container.find('.' + this.options.itemClass);
		//
		// Wait until all images have completely loaded
		//
		for (var i = 0; i < items.length; i++) {
			var item = items[i];
			if ((item.tagName === 'IMG') &&
				((item.width === undefined) || ((item.complete !== undefined) && !item.complete)))
				return;
		}

		clearInterval(this.initTimer);

		// Init items
		for (i = 0; i < items.length; i++) {
			this.items.push(new Item(items[i], this.itemOptions));
		}

		if (this.autoPlayAmount !== 0) this.enableAutoPlay();
		this.bindControls();
		this.render();

		if (typeof this.onLoaded === 'function')
			this.onLoaded(this);
	};
}
